export default __webpack_public_path__ + "static/media/payment1.5636639c.png";